/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  FETCH_OCVIEW,
  FETCH_OCVIEW_SUCCESS,
  FETCH_OCVIEW_FAILURE,
 
} from "./actionTypes";
import { Ocview } from "./ocviews";
import * as IntegrationError from "../../components/settings/integrations/IntegrationError";

function getResponseError(error) {
  if (error.response.data && error.response.data.message) {
    return error.response.data;
  } else {
    return IntegrationError.getDefaultError();
  }
}


export function fetchOcview() {
  return {
    type: FETCH_OCVIEW,
  };
}
export function fetchOcviewSuccess(ocviewinfo) {
  let ocViewsResponse=[];
  if(ocviewinfo && ocviewinfo.length==0)
  ocViewsResponse= [];
  else
  {
    for(let ocView of ocviewinfo)
    ocViewsResponse.push(ocView.viewId);

  }

  return {
    type: FETCH_OCVIEW_SUCCESS,
    ocviewinfo: ocViewsResponse,
  };
}
export function fetchOcviewFailure(error) {
  return {
    type: FETCH_OCVIEW_FAILURE,
    errorMessage: error.message,
  };
}

export function getOcviewData() {
  return (dispatch) => {
    dispatch(fetchOcview());
    return Ocview
      .getUser()
      .then((response) => dispatch(fetchOcviewSuccess(response.data)))
      .catch(function (error) {
        dispatch(fetchOcviewFailure(getResponseError(error)));
      });
  };
}
